import { css } from '@emotion/react'

const S = {
  basic: css`
    height: auto;
    &:not(.no-fill-current-color) > path {
      fill: currentColor;
    }
  `,
}

export default S
